import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import midas from '@resurs/midas'
import { Columns, Column, Button } from '@resurs/midas-react'
import { Conditional } from '@resurs/react-utils'
import NumberFormat from 'react-number-format'
import config from '../../../../../../../config'
import { getDeepOr } from '../../../../../util/helpers'
import { getText } from '../../../../../internal/TextLabels'
import { sendReceiptSummary } from '../../../../../store/actions/receipt-summary-actions'
import { format } from '../../../../../models/format'
import SendMailModalForm from '../../../../../components/SendMailModalForm'
import { CustomerTypeModel } from '../../../models/private-models'
import CurrencyFormat from '../../../../../components/common/CurrencyFormat'

class PaymentDoneContent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      emailAddress: this.props.current.selectedPaymentMethod
        ? PaymentDoneContent.getEmailAddress(
            this.props.payment,
            this.props.current.selectedPaymentMethod.customerType,
          )
        : '',
      showForm: false,
    }
  }

  static getEmailAddress(payment, customerType) {
    if (customerType === CustomerTypeModel.NATURAL) {
      return payment.paymentResult.customer.email || ''
    }
    return ''
  }

  getPaymentLogIndex() {
    const paymentLog = getDeepOr(
      [],
      this.props.payment.paymentResult,
      'payment.paymentLog',
    )
    return paymentLog.findIndex(({ type }) => type === 'DEBIT')
  }

  sendEmail() {
    this.props.sendReceiptSummary(
      this.props.payment.paymentResult.id,
      this.getPaymentLogIndex(),
      {
        email: this.state.emailAddress,
      },
    )
  }

  isValidEmail() {
    return this.state.emailAddress.match(format.email.regex)
  }

  render() {
    const cellStyle = {
      width: '28%',
      float: 'left',
      margin: '3px 0',
    }
    const textCellStyle = {
      width: '22%',
      float: 'left',
      textAlign: 'right',
      margin: '3px 0',
    }

    const isApplication = this.props.payment.paymentResult
      ? !!this.props.payment.paymentResult.application
      : false

    const isInputDisabled =
      this.props.current.selectedPaymentMethod &&
      this.props.current.selectedPaymentMethod.customerType ===
        CustomerTypeModel.NATURAL
        ? isApplication
        : false

    return (
      <Columns>
        <Column col12>
          <div>
            <div
              style={{
                display: 'inline-block',
                width: '100%',
                padding: '0 15px',
              }}
            >
              {this.props.result.account && (
                <>
                  <div style={{ width: '100%', clear: 'both' }}>
                    <div style={cellStyle}>
                      {getText('payApply.paymentDone.accountNumber')}{' '}
                    </div>
                    <div style={textCellStyle}>
                      <NumberFormat
                        value={this.props.result.account.accountNumber}
                        displayType="text"
                        format="#### #### #### ####"
                      />
                    </div>
                  </div>
                  {this.props.current.selectedCard && (
                    <div style={{ width: '100%', clear: 'both' }}>
                      <div style={cellStyle}>
                        {getText('payApply.paymentDone.existingCreditLimit')}{' '}
                      </div>
                      <div style={textCellStyle}>
                        <CurrencyFormat
                          value={this.props.current.selectedCard.approvedCredit}
                          hideDecimalIfInteger
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
              {this.props.result.application && (
                <div style={{ width: '100%', clear: 'both' }}>
                  <div style={cellStyle}>
                    {getText('payApply.applicationDone.approvedAmount')}{' '}
                  </div>
                  <div style={textCellStyle}>
                    <NumberFormat
                      value={this.props.result.application.approvedAmount}
                      displayType="text"
                      thousandSeparator=" "
                      renderText={val => getText('default.currency', val)}
                    />
                  </div>
                </div>
              )}
              <div style={{ width: '100%', clear: 'both' }}>
                <div style={cellStyle}>
                  {getText('payApply.paymentDone.amount')}{' '}
                </div>
                <div style={textCellStyle}>
                  <CurrencyFormat
                    value={
                      this.props.result.payment.paymentStatus.totalOrderAmount
                    }
                    hideDecimalIfInteger
                  />
                </div>
              </div>
            </div>
          </div>
          <Conditional when={!config.disableReceiptSummary}>
            <div
              style={{
                display: 'inline-block',
                marginTop: '50px',
                width: '100%',
                padding: '0 15px',
              }}
            >
              <div style={{ width: '80%', float: 'left' }}>
                <label
                  className={midas.formLabel}
                  style={{
                    marginRight: '10px',
                    verticalAlign: 'middle',
                    lineHeight: 2.3,
                  }}
                >
                  {getText('payApply.paymentDone.sendEMail')}
                </label>
              </div>
              <div
                style={{
                  width: '20%',
                  float: 'right',
                  textAlign: 'right',
                }}
              >
                <Button
                  onClick={() => this.setState({ showForm: true })}
                  text={getText('payApply.paymentDone.send')}
                />
              </div>
            </div>

            <SendMailModalForm
              inputValue={this.state.emailAddress}
              onChange={val => {
                this.setState({ emailAddress: val })
              }}
              onSubmit={() => {
                this.sendEmail()
              }}
              onClose={() => this.setState({ showForm: false })}
              disableInput={!this.isValidEmail()}
              show={this.state.showForm}
              disabled={isInputDisabled}
            />
          </Conditional>
        </Column>
        <Column col12 />
      </Columns>
    )
  }
}

PaymentDoneContent.propTypes = {
  result: PropTypes.object.isRequired,
  current: PropTypes.object.isRequired,
  payment: PropTypes.object.isRequired,
  sendReceiptSummary: PropTypes.func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  sendReceiptSummary: (paymentId, index, email) => {
    dispatch(sendReceiptSummary(paymentId, index, email))
  },
})

const mapStateToProps = state => {
  return {
    current: state.payApply.current,
    payment: state.payApply.payment,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDoneContent)
